import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Warning, Info } from '@material-ui/icons/'

const MessageContainer = styled.div`
  padding: ${props => props.theme.spacing(4)}px;
  display: flex;
  align-items: center;

  .message-icon {
    margin-right: ${props => props.theme.spacing(2)}px;
  }
`

const SuccessMessage = styled(MessageContainer)`
  background-color: #f5fbea;
  color: #7cb82f;
`

const WarningMessage = styled(MessageContainer)`
  background-color: #fff9ee;
  color: #f47b16;
`

const MessageTip = ({ messageHub }) => {
  const { message, status, loading } = messageHub

  return (
    <>
      {status === `success` && !loading && (
        <SuccessMessage>{message}</SuccessMessage>
      )}
      {status === `warning` && !loading && (
        <WarningMessage>
          <Warning className="message-icon" /> {message}
        </WarningMessage>
      )}
    </>
  )
}

MessageTip.propTypes = {
  messageHub: PropTypes.object,
}

export default MessageTip
